import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportingRoutingModule } from './reporting-routing.module';
import { ReportingComponent } from './reporting.component';
import { NgProgressModule } from 'ngx-progressbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component';
import { ReportingService } from '../services/reporting.service';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { NgxPaginationModule } from 'ngx-pagination';
import { AzureReportingDashboardComponent } from './azure-reporting-dashboard/azure-reporting-dashboard.component';
import { AzureReportingDetailsComponent } from './azure-reporting-dashboard/azure-reporting-details/azure-reporting-details.component';
import { NgxSortableModule } from 'ngx-sortable';
import { FiltersComponent } from './filters/filters.component';
import { FilterSubsectionComponent } from './filters/filter-subsection/filter-subsection.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { Ng2CompleterModule } from 'ng2-completer';
import { SummaryComponent } from './summary/summary.component';
import { CustomReportEditComponent } from './custom-report-edit/custom-report-edit.component';
import { LicenseReportingDashboardComponent } from './license-reporting-dashboard/license-reporting-dashboard.component';
import { SellThroughReportsComponent } from './sell-through-reports/sell-through-reports.component';
import { SharedService } from '../manage-subscriptions/shared/shared.service';
import { AzureCurrentUsageDetailsComponent } from './azure-reporting-dashboard/azure-current-usage-details/azure-current-usage-details.component';
import { BackorderReportsComponent } from './backorder-reports/backorder-reports.component';
import { OrderItemDetailComponent } from '../my-orders/order-item-detail/order-item-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EsdReportComponent } from './esd-report/esd-report.component';
import { EsdDetailViewComponent } from './esd-report/esd-detail-view.component';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { WebAuditLogComponent } from './web-audit-log/web-audit-log.component';
import { MatButtonModule } from '@angular/material/button';
import { UpcomingMicrosoftCSPRenewalsComponent } from './upcoming-microsoft-csp-renewals/upcoming-microsoft-csp-renewals.component';
import { NCEOrderReportComponent } from './nce-orders-report/nce-orders-report.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [
    CommonModule,
    NgProgressModule,
    NgxPaginationModule,
    NgbModule,
    ReportingRoutingModule,
    SharedModule,
    FormsModule,
    MatSortModule,
    MatInputModule,
    // NgxSortableModule,
    Ng2CompleterModule,
    NgSelectModule,
    ChildHeaderModule,
    BreadcrumbModule,
    MatButtonModule,
    MatTooltipModule,
    MatSlideToggleModule
  ],
  declarations: [
    ReportingComponent,
    ReportingDashboardComponent, 
    AzureReportingDashboardComponent, 
    AzureReportingDetailsComponent, 
    LicenseReportingDashboardComponent,
    CustomReportEditComponent,
    FiltersComponent,
    FilterSubsectionComponent,
    SchedulingComponent,
    SummaryComponent, 
    CustomReportEditComponent,
    LicenseReportingDashboardComponent, 
    SellThroughReportsComponent, 
    AzureCurrentUsageDetailsComponent, 
    BackorderReportsComponent,
    EsdReportComponent,
    EsdDetailViewComponent,
    WebAuditLogComponent,
    UpcomingMicrosoftCSPRenewalsComponent,
    NCEOrderReportComponent,
   
  ],
  providers: [
    ReportingService,
    SharedService
  ]
})
export class ReportingModule { }